import { create } from 'zustand';
import { SelectedQuote, selectedQuotesState } from '../../types/storeTypes';

// Define the store
const useSelectedQuotesStore = create<selectedQuotesState>((set) => ({
  selectedQuotes: [],
  add: (quote: SelectedQuote) =>
    set((state) => {
      return { selectedQuotes: [...state.selectedQuotes, quote] };
    }),
  remove: (quoteId: string) =>
    set((state) => ({
      selectedQuotes: state.selectedQuotes.filter(
        (item) => item.id !== quoteId,
      ),
    })),
  clear: () => set({ selectedQuotes: [] }),
}));

export default useSelectedQuotesStore;
